<template>
  <CustomRuleModal class="modal-app-upgrade"
    :name="modalName"
    :show-close="true"
    :cover-closeable="true"
    :cover-handler="handleCloseCover"
    @modalClose="handleClose"
  >
    <div class="content"
      slot="modal-content"
    >
    <div class="ruleTitle">活动规则</div>
    <div class="contentBox">
      <div class="ruleContont"
       :style="{
          backgroundImage: `url(${ruleContont})`,height:Height
        }"></div>
    </div>

    </div>
  </CustomRuleModal>
</template>

<script>

import CustomRuleModal from './CustomRuleModal.vue';

export default {
  name: 'ModalRule',
  components: {
    CustomRuleModal
  },
  data() {
    return {
      modalName: 'modalRuleShow'
    };
  },
  props: {
    ruleContont: {
      default: ''
    },
    Height: {
      type: String,
      default: '',
    }

  },
  mounted() {
    console.log(this.Height);
  },
  methods: {
    /**
     * 这里可以自定义关闭行为
     */
    handleClose() {
      // 执行一些自定义方法
      // 这里需要使用主图的关闭方法
      this.$emit('modalHandler', 'modalClose', this.modalName);
    },
    /**
     * 关闭按钮处理
     */
    handleCloseBtn() {
    },
    /**
    * 自定义蒙层关闭
    */
    handleCloseCover() {
      this.$emit('modalHandler', 'modalClose', this.modalName);
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/common-mixin.scss";
.modal-app-upgrade{
  .modal{
    background: #fff;
  }
  .content{
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    overflow: auto;
    background: #fff;
    border-radius: rpx(50) rpx(50) rpx(0) rpx(0);
    padding: rpx(110) 0 rpx(30) 0;
    .ruleTitle{
      font-size: rpx(40);
      color:#333;
      font-weight: bold;
      position: absolute;
      top: rpx(40);
      left: rpx(30);
    }
    .contentBox{
      width: rpx(750);
      height: rpx(810);
      overflow-y: scroll;
      .ruleContont{
        width: rpx(750);
        height: rpx(750);
        background: center no-repeat;
        background-size: 100% 100%;
      }
    }
  }
}

</style>
